import { useEffect, useState } from 'react';

type InputMode = 'keyboard' | 'pointer';

const useInputMode = () => {
  const [mode, setMode] = useState<InputMode>('pointer');

  useEffect(() => {
    const onKeyDown = () => setMode('keyboard');
    const onPointer = () => setMode('pointer');

    window.addEventListener('keydown', onKeyDown);
    window.addEventListener('mousedown', onPointer);
    window.addEventListener('touchstart', onPointer);

    return () => {
      window.removeEventListener('keydown', onKeyDown);
      window.removeEventListener('mousedown', onPointer);
      window.removeEventListener('touchstart', onPointer);
    };
  }, []);

  return mode;
};

export default useInputMode;
